import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Section = styled.section`
  padding: 80px 5%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Inner = styled.div`
  display: flex;
  justify-content: center;
`;

const TextBlock = styled.div`
  /* max-width: 750px; */

  h1 {
    font-size: 2.2rem;
    color: #0f172a;
    margin-bottom: 12px;

    span {
      color: #005f73;
    }
  }

  p {
    font-size: 1.05rem;
    line-height: 1.8;
    color: #475569;
    margin-bottom: 14px;
  }
`;

const Brand = styled.span`
  color: #005f73;
  font-weight: 600;
`;

const Divider = styled.div`
  width: 60px;
  height: 3px;
  background: #005f73;
  margin: 25px 0;
  border-radius: 2px;
`;

export const Tagline = styled.h3`
  font-size: 1.15rem;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 16px;
`;

const CardsGrid = styled.div`
  margin-top: 70px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
`;

const BlockContainer = styled.div`
  display: flex;
`;
const ImageContainer = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`;

const TextContainer = styled.div`
  @media (max-width: 900px) {
    padding: 10px;
  }
`;

const NewCard = styled.div`
  position: relative;
  background: #ffffff;
  padding: 22px;
  border-radius: 14px;
  border: 1px solid #eaeaea;

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  /* 🔥 PERFORMANCE FIX */
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 40px 40px rgba(5, 51, 103, 0.06);
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.06);
  }

  &:hover {
    box-shadow: 0 10px 20px #1e293b;
  }

  h5 {
    font-size: 1.15rem;
    color: #0f172a;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.95rem;
    color: #64748b;
    margin: 0;
  }
`;

const TopAccent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background: #005f73;
`;

const WhoWeAre = () => {
  return (
    <Section>
      <Inner>
        <TextBlock as={motion.div}>
          <BlockContainer>
            <ImageContainer>
              <img
                src="/assets/homePageImg2.png"
                alt="Who We Are"
                style={{ width: "400px", marginRight: "40px" }}
              />
            </ImageContainer>
            <TextContainer>
              <h1>
                Who <span>We</span> Are?
              </h1>
              <Tagline>
                Empowering <span>Smarter Financial</span> Choices
              </Tagline>
              <p>
                At <Brand>Wealthies.in</Brand>, we believe financial clarity
                should be simple, accessible, and pressure-free.
              </p>
              <p>
                We focus on helping individuals understand insurance and
                financial concepts in a structured way — so they can make
                informed decisions with confidence.
              </p>
              <p>
                Our platform is designed to simplify complexity and provide
                meaningful guidance at every stage.
              </p>
            </TextContainer>
          </BlockContainer>
          <Divider />
          <BlockContainer>
            <TextContainer>
              <h1>
                Why <span>Wealthies</span>?
              </h1>
              <Tagline>
                Because Smart Decisions Need Clear Understanding
              </Tagline>
              <p>
                We simplify insurance and financial topics into practical,
                real-world insights — helping individuals move forward with
                clarity instead of confusion.
              </p>
              <p>
                Whether it’s understanding coverage, exploring options, or
                navigating processes, we aim to make every step easier.
              </p>
            </TextContainer>
            <ImageContainer>
              <img
                src="/assets/homePageImg1.png"
                alt="Why Wealthies?"
                style={{ width: "400px", marginRight: "40px" }}
              />
            </ImageContainer>
          </BlockContainer>
        </TextBlock>
      </Inner>

      <CardsGrid>
        {[
          {
            title: "Free to Connect",
            desc: "Access financial guidance without unnecessary barriers",
          },
          {
            title: "Wealthies Shield",
            desc: "Support that continues beyond policy purchase",
          },
          {
            title: "Expert Support",
            desc: "Connect with professionals when you need clarity",
          },
        ].map((item, i) => (
          <NewCard
            key={i}
            as={motion.div}
            // initial={{ opacity: 0, y: 30 }}
            // animate={{ opacity: 1, y: 0 }}
            // transition={{
            //   duration: 0.4,
            //   delay: i * 0.08,
            //   ease: "easeOut",
            // }}
          >
            <TopAccent />
            <h5>{item.title}</h5>
            <p>{item.desc}</p>
          </NewCard>
        ))}
      </CardsGrid>
    </Section>
  );
};

export default WhoWeAre;

export const BrandWrapper = styled.span`
  color: #005f73 !important;
  font-weight: bold;
`;

export const Content = styled.div`
  flex: 1 1 40%;
  display: flex;
  flex-direction: column;
  /* max-width: 60%; */
  span {
    color: #fdc500;
  }
  h1 {
    font-size: 2.5rem;
    color: #005f73;
    margin: 0;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #333;
  }

  h2 {
    text-align: center;
  }

  @media (max-width: 900px) {
    h1 {
      font-size: 2rem;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  margin-top: 80px;
  margin-bottom: 80px;

  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .card-body i {
    font-size: 2rem;
    background: linear-gradient(135deg, #005f73, #00aaff);
    color: #fff;
    padding: 18px;
    border-radius: 50%;
    box-shadow: 0 8px 20px rgba(0, 119, 204, 0.3);
    transition: transform 0.4s ease;
  }

  .card:hover .card-body i {
    transform: scale(1.2) rotate(10deg);
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .card-content h5 {
    font-size: 1.4rem;
    color: #003366;
    margin: 0;
  }

  .card-content p {
    font-size: 1.1rem;
    color: #333;
    margin: 0;
    line-height: 1.5;
  }

  @media (max-width: 900px) {
    gap: 30px;

    .card {
      width: 90%;
    }
  }
`;

export const Card = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 50px 30px 30px;
  width: 300px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition:
    transform 0.4s ease,
    box-shadow 0.4s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;

  &:hover {
    transform: translateY(-15px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
`;

export const Icon = styled.i`
  font-size: 2.2rem;
  color: #005f73;
`;

export const CardContent = styled.div`
  h5 {
    font-size: 1.3rem;
    color: #005f73;
    margin: 0 0 5px 0;
  }

  p {
    margin: 0;
    color: #555;
    font-size: 1rem;
  }
`;
